import React from 'react';
import DocumentsForm from '../components/AccountForms/DocumentsForm';
import Page from '../components/Page';

function Documents() {
  return (
    <Page>
      <DocumentsForm />
    </Page>
  );
}

export default Documents;
